export default "__VITE_ASSET__b2d8f8e5__"